<template>
  <el-dialog title="Associated Record" :close-on-click-modal="false" :visible.sync="visible" width="1200px" top="3vh">
    <div class="pb20">
      <el-table border :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column label="Linked Transaction No." prop="linkedApplymentNo" align="center"></el-table-column>
        <el-table-column label="Company" prop="companyName" align="center"></el-table-column>
        <el-table-column label="Submit Time" prop="commitTime" align="center"></el-table-column>
        <el-table-column label="Time of application completion" prop="finishTime" align="center"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin.js";
export default {
  mixins: [paginationMixin],
  components: { Pagination },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
      id: null,
    };
  },
  methods: {
    async init(id) {
      this.id = id;
      this.visible = true;
      await this.$nextTick();
      this.getDataList(1);
    },
    // 获取分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const { code, data } = await this.$http.get("/admin/stNomineeDirectorManage/getApplyInfoPage", {
        params: {
          current: this.current,
          size: this.pageSize,
          id: this.id,
        },
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
  },
};
</script>
